var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "Distributor in Korea",
      "tabActive": "Mitsubishi O-Ring",
      "bg": "/images/sub/visual/sv3.png"
    }
  }), _c('section', {
    staticClass: "sub-section sub-section--first"
  }, [_c('v-container', [_c('h2', {
    staticClass: "page-tit mb-lg-42"
  }, [_vm._v(" Mitsubishi O-Ring ")])]), _c('sub-bg-image', {
    attrs: {
      "src": "/images/sub/distributor/oring/oring-top-img.png",
      "className": "h-lg-400px"
    }
  }, [_c('h3', {
    staticClass: "tit font-weight-semibold mb-8 mb-md-50 mb-lg-100"
  }, [_vm._v(" MITSUBISHI CABLE is a Japanese company with a history of about 100 years since its foundation in 1917. ")]), _c('p', {
    staticClass: "page-text color-grey-51 mb-2 mb-lg-10"
  }, [_vm._v(" Rubber O-Ring products have been produced since 1958 at the request of the Japanese Ministry of Defense. ")]), _c('p', {
    staticClass: "page-text color-grey-51 mb-2 mb-lg-10"
  }, [_vm._v(" Through the know-how gained through long experience, we are expanding innovative solutions based on our core competencies, material composite technology, design technology, and production engineering. ")]), _c('p', {
    staticClass: "page-text color-grey-51"
  }, [_vm._v(" The selection of materials is very wide, and the optimal design according to the order is applied, and it is receiving high recommendations and interest from various industries. ")])])], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "Advantages"
    }
  }, [_c('p', {
    staticClass: "page-text color-grey-51 mb-30 mb-lg-52"
  }, [_vm._v(" We can supply rubber O-Rings (EPDM, Silicon, FKM) and Metal O-Rings to all fields, and our product line responds to a wide range of industrial fields. "), _c('br'), _vm._v(" We always welcome inquiries about O-Rings requested at the device design stage. ")]), _c('v-row', [_c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/oring/oring-icon1.png",
      "iconWidth": "49",
      "num": "01"
    }
  }, [_vm._v(" Very wide material selection ")]), _c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/oring/oring-icon2.png",
      "iconWidth": "50",
      "num": "02"
    }
  }, [_vm._v(" Apply the optimal design according to the order ")]), _c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/oring/oring-icon3.png",
      "iconWidth": "49",
      "num": "03"
    }
  }, [_vm._v(" Can supply Rubber O-Ring and Metal O-Ring to all fields ")]), _c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/oring/oring-icon4.png",
      "iconWidth": "50",
      "num": "04"
    }
  }, [_vm._v(" The product line can respond to a wide range of industries ")])], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "Mitsubishi O-Ring",
      "className": "full"
    }
  }, [_c('v-row', {
    staticClass: "my-n10 my-lg-n40"
  }, [_c('v-col', {
    staticClass: "py-10 py-lg-40",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('image-detail', {
    attrs: {
      "tit": "Metal O-ring",
      "src": "/images/sub/distributor/oring/oring-img3-1.png"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10 mb-4 mb-lg-20"
  }, [_vm._v(" Under severe conditions such as high temperature and high pressure, MITSUBISHI CABLE Metal O-ring can maintain and withstand high sealing properties in severe ultra-high vacuum and cryogenic temperatures ")]), _c('p', {
    staticClass: "bar-txt font-size-14 font-size-lg-16 color-grey-2c mb-2 mb-lg-8"
  }, [_vm._v(" - Possibility of use in 270 °C ~ +700 °C ")]), _c('p', {
    staticClass: "bar-txt font-size-14 font-size-lg-16 color-grey-2c mb-2 mb-lg-8"
  }, [_vm._v(" - Ultra High Vacuum : (1.3×10-10Pa) ")]), _c('p', {
    staticClass: "bar-txt font-size-14 font-size-lg-16 color-grey-2c"
  }, [_vm._v(" - Steady sealing performance at ultra-high pressure : 300MPa (3000kgf /cm2) ")])])], 1), _c('v-col', {
    staticClass: "py-10 py-lg-40",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('image-detail', {
    attrs: {
      "tit": "Rubber Seal",
      "src": "/images/sub/distributor/oring/oring-img3-2.png"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10"
  }, [_vm._v(" With the know-how gained through the manufacture of integrated sealing materials, which has manufactured/supplied rubber sealing of many different materials, we provide solutions to meet each request through the best blend of optimum shape design capabilities. ")])])], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "sub-section sub-section--last"
  }, [_c('v-container', [_c('inquiry', {
    attrs: {
      "src": "/images/sub/distributor/oring/oring-img1.png",
      "name": "D.H YOO",
      "tel": "+82-31-765-2268",
      "mail": "davidyoo@ist-co.kr",
      "fax": "+82-31-765-2389",
      "link": "https://www.mitsubishi-cable.co.jp/en/products/group/seal/index.html",
      "linkBg": "/images/sub/distributor/oring/oring-img2.png"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }